import React, { useEffect, useState } from "react";

type ScaleFadeProps = {
  isOpen: boolean;
  appear?: boolean;
  respectReduceMotion?: boolean;
  hover?: boolean;
  hoverOnContainer?: boolean;
  className?: string;
  children?: React.ReactNode;
};

const ScaleFade: React.FC<ScaleFadeProps> = ({
  isOpen,
  appear = true,
  respectReduceMotion = true,
  hover = false,
  hoverOnContainer = false,
  className,
  children,
}) => {
  const [hasAppeared, setHasAppeared] = useState(!appear);
  
  const shouldShow = appear ? (hasAppeared && isOpen) : isOpen;

  useEffect(() => {
    if (appear && isOpen && !hasAppeared) {
      const id = requestAnimationFrame(() => setHasAppeared(true));
      return () => cancelAnimationFrame(id);
    }
    if (appear && !isOpen && hasAppeared) {
      setHasAppeared(false);
    }
    return undefined;
  }, [appear, isOpen, hasAppeared]);

  const reduceMotionClasses = respectReduceMotion
    ? "motion-reduce:transition-none motion-reduce:transform-none"
    : "";

  const hoverClasses = hoverOnContainer
    ? "hover:scale-110 transition-transform duration-200 ease-out"
    : hover
    ? "hover-capable"
    : "";

  return (
    <div
      className={`${
        className ?? ""
      } transform-gpu [backface-visibility:hidden] duration-300 ease-out ${reduceMotionClasses} ${hoverClasses} ${
        shouldShow
          ? "opacity-100 translate-y-0 scale-100 pointer-events-auto visible"
          : "opacity-0 -translate-y-1 scale-95 pointer-events-none"
      }`}
      style={{ transitionProperty: "opacity, transform" }}
    >
      {children}
    </div>
  );
};

export default ScaleFade;
